import axios from 'axios';

export const VerifyGstApi = async (ApiStatus,gst,token) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    try {
        let res = await axios.get("https://kycapi.microvistatech.com/api/v1/GstinVerification/GstinSearch?gstin="+gst+"&TokenID=ATRWBJJE&TokenSecret=V2F6CLYCUVQ2", {
            headers: {
                'Authorization': "Bearer " + token,
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}